import { render, staticRenderFns } from "./bimPhoneRequest.vue?vue&type=template&id=4dbe6e4c&scoped=true&"
import script from "./bimPhoneRequest.vue?vue&type=script&lang=js&"
export * from "./bimPhoneRequest.vue?vue&type=script&lang=js&"
import style0 from "./bimPhoneRequest.vue?vue&type=style&index=0&id=4dbe6e4c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbe6e4c",
  null
  
)

export default component.exports